
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
          Urls
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-input
        type="textarea"
        class="textarea-stripe-container"
        placeholder="Please input url regexes to block, one regex per line"
        autosize
        v-model="url">
        </el-input>
      </el-row>
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SetUrlBlocklist',
  props: {
    key: {
      type: Number
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      name: 'Set URL Blocklist',
      desc: 'Set list of forbidden urls for browser to block',
      url: this.prepareParam(this, 'urls'),
    }
  },
  methods: {
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading'
    })
  },
  watch: {
    url(newValue, oldValue) {
        this.model.params.urls = newValue.replace(/\r\n/g,"\n").split("\n");
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
